import styled, { css } from 'styled-components';
import { Select } from '../../select';
/**
 * Dropdown select
 */
export const dropdownSelectStyles = () => css `
	flex: auto;
	width: auto;
`;
export const DropdownSelect = styled(Select) `
	${dropdownSelectStyles}
`;
